import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  LayoutDashboard,
  Package,
  ShoppingCart,
  Users,
  Tags,
  Settings,
  LogOut,
  Percent,
  Heart,
  Boxes,
} from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_e131690a-29c3-4d23-95c5-ed4c8b1f1813/artifacts/sej3xy3x_GathaVaani_Logo.jpeg";

const navItems = [
  { path: "/", icon: LayoutDashboard, label: "Dashboard" },
  { path: "/products", icon: Package, label: "Products" },
  { path: "/orders", icon: ShoppingCart, label: "Orders" },
  { path: "/customers", icon: Users, label: "Customers" },
  { path: "/inventory", icon: Boxes, label: "Inventory" },
  { path: "/carts", icon: ShoppingCart, label: "Carts" },
  { path: "/wishlists", icon: Heart, label: "Wishlists" },
  { path: "/coupons", icon: Percent, label: "Coupons" },
  { path: "/settings", icon: Settings, label: "Settings" },
];

export default function Sidebar() {
  const { admin, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <aside className="fixed left-0 top-0 h-screen w-64 bg-sidebar border-r border-[#E7E5E4] flex flex-col z-50">
      {/* Logo */}
      <div className="p-4 border-b border-[#E7E5E4]">
        <div className="flex items-center gap-3">
          <img
            src={LOGO_URL}
            alt="GathaVaani"
            className="h-12 w-auto object-contain"
          />
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              isActive ? "sidebar-item-active" : "sidebar-item"
            }
            data-testid={`nav-${item.label.toLowerCase()}`}
          >
            <item.icon className="w-5 h-5" />
            <span className="font-medium">{item.label}</span>
          </NavLink>
        ))}
      </nav>

      {/* User Info & Logout */}
      <div className="p-4 border-t border-[#E7E5E4]">
        <div className="mb-3 px-2">
          <p className="text-sm font-medium text-primary truncate">
            {admin?.name}
          </p>
          <p className="text-xs text-muted-foreground truncate">
            {admin?.email}
          </p>
        </div>
        <button
          onClick={handleLogout}
          className="sidebar-item w-full text-red-600 hover:bg-red-50 hover:text-red-700"
          data-testid="logout-btn"
        >
          <LogOut className="w-5 h-5" />
          <span className="font-medium">Logout</span>
        </button>
      </div>
    </aside>
  );
}
